module.exports = __webpack_public_path__ + "static/media/AXSG+Banner+No+Logo.7478055d.jpg";